import { FC, useState, MouseEvent, memo } from 'react';
import TuneIcon from '@mui/icons-material/Tune';

import { Menu, MenuItem, SxProps, Tooltip } from '@mui/material';
import { StyledButton } from './styles';

interface FilterButtonProps {
  options: { name: string; key: string }[];
  onSelect: (key: string) => void;
  disabled: boolean;
  hasSelected?: boolean;
  customFilterSx?: SxProps;
}

export const FilterButton: FC<FilterButtonProps> = memo(
  ({ options, onSelect, disabled, hasSelected, customFilterSx }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const menuOpen = Boolean(anchorEl);

    const onClickOpen = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

    const onClickClose = () => setAnchorEl(null);

    const onClickItem = (key: string) => () => {
      onSelect(key);
      setAnchorEl(null);
    };

    return (
      <>
        <StyledButton
          sx={customFilterSx}
          variant="outlined"
          onClick={onClickOpen}
          color="black"
          className={menuOpen || (hasSelected && !disabled) ? 'active' : ''}
          disabled={disabled}
        >
          <Tooltip title="Add filters">
            <TuneIcon />
          </Tooltip>
        </StyledButton>
        <Menu anchorEl={anchorEl} open={menuOpen} onClose={onClickClose}>
          {options.map(({ name, key }) => (
            <MenuItem key={key} onClick={onClickItem(key)}>
              {name}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  },
);
